/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { memoize } from 'lodash/fp';
import cx from 'classnames';

import Responsive from 'app/components/responsive/Responsive';
import Columns from 'app/components/commons/Columns';
import { setSortField } from 'app/actions/playerListActions';

import TableHeadCell from './TableHeadCell';

type Props = {
  hasScrollbar?: boolean,
  className?: string,
  columns: Array<Object>,
  onSort: string => void,
  sortDirection?: 'asc' | 'desc',
  sortField?: string
};

// const StyledColumns = styled(Columns)(({ theme }) => ({
//   backgroundColor: theme.color.basis6,
//   borderTop: '2px solid',
//   borderColor: theme.color.basis5,
//   color: theme.color.basis1,
//   fontSize: '0.8rem',
//   borderBottom: '2px solid white'
// }));

export const StyledColumns = styled(Columns)(({ theme, hasScrollbar }) => ({
  backgroundColor: theme.color.basis6,
  borderTop: '2px solid',
  borderColor: theme.color.basis5,
  color: theme.color.basis1,
  fontSize: theme.fontSize.xxsmall,
  paddingLeft: theme.spacing.tiny,
  paddingRight: theme.spacing.tiny,
  borderBottom: '2px solid white',
  [theme.mediaQuery.desktopAndUp]: hasScrollbar
    ? {
        // paddingRight: 0 // vertical scroll bar
      }
    : {}
}));

const defaultProps = {
  hasScrollbar: false,
  className: undefined,
  sortDirection: undefined,
  sortField: undefined
};

const TableHead = ({
  className,
  columns,
  onSort,
  hasScrollbar,
  sortDirection,
  sortField
}: Props) => {
  const handleSort = memoize((field: string) => () => {
    onSort(field);
  });

  const sortDirAttr = (field: string) => {
    return field === sortField ? sortDirection : undefined;
  };

  return (
    <StyledColumns className={cx('is-mobile', className)} hasScrollbar={hasScrollbar}>
      {columns.map(
        ({
          field,
          label,
          tabletLandscapeAndUp = false,
          narrow,
          width,
          largeScreenWidth,
          size,
          sortable = true
        }) => (
          <Responsive
            key={field}
            mobile={!tabletLandscapeAndUp}
            tabletPortrait={!tabletLandscapeAndUp}
            tabletLandscape
            desktopAndUp
          >
            <TableHeadCell
              key={field}
              size={size}
              width={width}
              largeScreenWidth={largeScreenWidth}
              narrow={narrow}
              onClick={sortable && field ? handleSort(field) : undefined}
              sortDir={sortable && field ? sortDirAttr(field) : undefined}
            >
              {label}
            </TableHeadCell>
          </Responsive>
        )
      )}
    </StyledColumns>
  );
};

TableHead.defaultProps = defaultProps;

const connector = connect(
  state => ({
    sortDirection: state.challenge.sortDirection,
    sortField: state.challenge.sortField
  }),
  {
    onSort: setSortField
  }
);

export default connector(TableHead);
